// console.log all actions
import { ActionReducer, MetaReducer } from '@ngrx/store';

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    //console.debug(action.type)

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [debug];
